<template>
  <div class="technology">
    <div class="m-top-box">
		<Nav/>
		<div class="m-layout-center">
			<h2>核心技术</h2>
		</div>
    </div>
	<div class="m-layout-center">
		<div class="pt40">
        <div class="tac mb50 m-main-tit">
					<h3 class="s-main-color1">技术架构</h3>
					<div class="u-line"></div>
				</div>
				<div class="m-list">
					<ul class="con mr70">
						<span class="h82"><img src="../assets/images/hxjs_jsjg_01@2x.png"></span>
						<li>
							<p class="title">区块链</p>
							<p class="det">基于区块链面向企业提供数据服务的快速部署，保障所有节点上的需求都能快速响应。完善的用户、密钥、权限管理及隔离处理，不仅保障数据、账户信息安全，又满足金融机构、企业、公益组织的需求</p>
						</li>
					</ul>
					<ul class="con">
						<span class="h80"><img src="../assets/images/hxjs_jsjg_02@2x.png"></span>
						<li>
							<p class="title">供应链</p>
							<p class="det">全方位的供应链管理，规范业务流程运作，汇集供应链上所有数据。通过供应链一体化服务平台，确保所有节点安全可控</p>
						</li>
					</ul>
					<div class="u-line-list"></div>
					<ul class="con mt40 mr70">
						<span class="h78"><img src="../assets/images/hxjs_jsjg_03@2x.png"></span>
						<li>
							<p class="title">支付功能</p>
							<p class="det">支持快速扩展其他平台的支付功能，实现平台信息流和资金流的统一管理</p>
						</li>
					</ul>
					<ul class="con mt40">
						<span class="h110"><img src="../assets/images/hxjs_jsjg_04@2x.png"></span>
						<li>
							<p class="title">统一账户</p>
							<p class="det">围绕统一身份编码聚合各类标签数据资源和行为数据资源，为数据模型的高效执行提供基础</p>
						</li>
					</ul>
					<div class="u-line-list2"></div>
					<div class="tac mb40">
						<img src="https://alicdn.jinhui365.com/res/cms/activity/cloudcode/images/hxjs_jsjg_05@2x.png" alt="" width="1003" height="1006" class="mt20">  
					</div>
				</div>
				<div class="clear"></div>
				<div class="tac mb40 m-main-tit">
					<h3 class="s-main-color1">核心技术简介</h3>
					<div class="u-line"></div>
				</div>
				<div class="m-tec-title">
					<span></span>区块链
				</div>
				<div class="m-block fl mb5">
					<p class="m-block-fl fl">
						云码通构建了自主知识产权的区块链底层技术平台，以数字化信任为核心思想，通过综合利用P2P 网络、算法、密码学、AI 等技术，结合具体应用场景，提供共享账本、点对点交易、私密交易、可追溯交易、智能交易等服务，在共识机制、隐私保护、智能合约等方面进行了技术创新，系统的稳定性、安全性、效率性在多个生产性应用中得以检验和完善
					</p>
					<div class="m-block-fr fl">
						<img src="../assets/images/hxjs_hxjs_01@2x.png" alt="" width="337" height="242">
					</div>
				</div>
				<div class="clear"></div>
				<div class="m-tec-title">
					<span></span>支付系统
				</div>
				<div class="m-pay">
						<p class="s-gray-color1 f14 lh24">云码通帮助企业快速接通各类支付功能</p>
						<ul class="m-pay-list">
							<li class="mr70">
								<p><img src="../assets/images/cpzx_icon1@2x.png" class="one"></p>
								<span class="s-gray-color2">快捷支付</span>
							</li>
							<li class="mr70">
								<p ><img class="two" src="../assets/images/cpzx_icon2@2x.png"></p>
								<span class="s-gray-color2">网关支付</span>
							</li>
							<li class="mr70">
								<p><img class="three" src="../assets/images/cpzx_icon3@2x.png"></p>
								<span class="s-gray-color2">认证支付</span>
							</li>
							<li class="mr70">
								<p><img class="four" src="../assets/images/cpzx_icon4@2x.png"></p>
								<span class="s-gray-color2">码支付</span>
							</li>
							<li>
								<p><img class="five" src="../assets/images/cpzx_icon5@2x.png"></p>
								<span class="s-gray-color2">商业委托支付</span>
							</li>
						</ul>
				</div>
				<div class="m-tec-title">
					<span></span>统一账户体系
				</div>
				<div class="m-account mb40">
					<p>统一账户系统是一套独立的账户系统，可以与其它各个系统完成账户级别的对接，通过账户对接可完成各种数据的采集及登记，同时为下一步与各个接入账户进行业务交互做好基础准备</p>
					<div class="tac mt40">
						<img src="https://alicdn.jinhui365.com/res/cms/activity/cloudcode/images/hxjs_hxjs_03@2x.png" width="706" height="492" alt="">
					</div>
				</div>
				<div class="m-tec-title">
					<span></span>供应链金融
				</div>
				<div class="m-finance">
					<p class="title">云码通专注于供应链风险数据的管理，为打通产业和资金上的瓶颈提供帮助，优化链上企业融资效率</p>
					<ul class="m-finance-list">
						<li class="mr66">
							<p class="s-gray-color2 f16">应收款模式</p>
							<p class="blue">成本低&nbsp;流程简便</p>
							<p class="img"><img src="../assets/images/hxjs_hxjs_gyl_01@2x.png" class="one"></p>
							<p class="blue">适用对象：供应商 上游企业</p>
						</li>
						<li class="mr66">
							<p class="s-gray-color2 f16">预付款模式</p>
							<p class="blue">流程简单&nbsp;放款快速</p>
							<p class="img"><img src="../assets/images/hxjs_hxjs_gyl_02@2x.png" class="one"></p>
							<p class="blue">适用对象：贸易商 中下游企业</p>
						</li>
						<li>
							<p class="s-gray-color2 f16">货物质押模式</p>
							<p class="blue">第三方监管&nbsp;量身定做</p>
							<p class="img"><img src="../assets/images/hxjs_hxjs_gyl_03@2x.png" class="one"></p>
							<p class="blue">适用对象：拥有货权的中上游企业</p>
						</li>
					</ul>
				</div>
		</div>
	</div>
  </div>
</template>
<style scoped lang="scss">
	@mixin textStyle {
		font-size: 14px;
		line-height: 24px;
		color: #787878;
	}
	.m-top-box
	{ 
		width: 100%; 
		padding-top: 10px;
		height: 390px; 
		background: url(https://alicdn.jinhui365.com/res/cms/activity/cloudcode/images/hxjs_banner.png) no-repeat center top;
		background-size:cover; 
		h2 
		{
			color: #fff;
			font-size: 68px;
			font-weight: 500;
			text-align: center;
			height: 100px;
			line-height: 100px;
			margin-top: 166px;
    }
  }
	.m-list
	{
		float: left;
		padding-left: 20px;
		position: relative;
		.con
		{
			float: left;
			width: 470px;
			margin-bottom: 20px;
			span
			{
				width: 100px;
				display: inline-block;
				float: left;
				img
				{
					width: 100%;
				}
			}
			li
			{
				float: left;
				width: 330px;
				margin-left: 34px;			
				@include textStyle;
				.title
				{
					font-size: 18px;
					color: #525252; 
					margin-bottom: 8px;
					line-height: 36px;
				}
				.det
				{
					line-height: 24px;
				}
			}
		}
		.u-line-list
		{
			clear: both;
			border: 1px solid #fff;
		}
		.u-line-list2
		{
			height: 290px;
			position: absolute;
			left: 549px;
			top: 20px;
			border-left: 1px solid #fff;
		}
	}
	.m-tec-title
	{
		padding-left: 30px;
		font-size: 18px;
		color: #525252;
		height: 26px;
		line-height: 26px;
		margin-bottom: 10px;
		span
		{
			display: inline-block;
			float: left;
			width: 30px;
			height: 2px;
			background: #525252;
			margin-right: 20px;
			margin-top: 12px;
		}
	}
	.m-block-fl
	{
		width: 580px;
		@include textStyle;
		margin-left: 80px;
		line-height: 28px;
		margin-right: 50px;
	}
	.m-block-fr
	{
		position: relative;
		margin-top: -64px;
	}
	.m-pay
	{
		font-size: 20px;
		padding-left: 80px;
		.m-pay-list
		{
			margin-top: 20px;
			padding-left: 10px;
			margin-bottom: 26px;
			overflow: hidden;
			p
			{
				height: 112px;
			}
			.one
			{
				width: 120px;
				height: 95px;
			}
			.two
			{
				width: 141px;
				height: 106px;
			}
			.three
			{
				width: 120px;
				height: 112px;
			}
			.four
			{
				width: 120px;
				height: 110px;
			}
			.five
			{
				width: 120px;
				height: 98px;
			}
			li{
				float: left;
				text-align: center;
			}
		}
	}
	.m-account
	{
		p
		{
			width: 930px;
			@include textStyle;
			line-height: 28px;
			margin-left: 80px;
			margin-bottom: 40px;
		}
	}
	.m-finance
	{
		margin-left: 80px;
		.title
		{
			@include textStyle;
			width: 760px;
			line-height: 28px;
			margin-bottom: 30px;
		}
	}
	.m-finance-list
	{
		overflow: hidden;
		margin-bottom: 64px;
		li
		{
			float: left;
			text-align: center;
			.blue
			{
				font-size: 14px;
				color: #2892E7 ;
			}
			.img
			{
				height: 194px;
			}
			.one
			{
				width: 286px;
				height: 174px;
				margin-top: 10px;
				margin-bottom: 10px;
			}
		}
	}
 </style>
<script>
import Nav from '@/components/Nav.vue'
export default {
  name:'technology',
  components: {
    Nav
  }
}
</script>